import React, { FC, HTMLAttributes } from 'react'
import { filterProps } from 'theme-system'

type BoxProps = Omit<HTMLAttributes<HTMLElement>, 'color'> & {
  as?: React.ElementType
}

export const StyledBox: FC<BoxProps> = ({ children, className, as = 'div', ...rest }) => {
  const Element = as
  return (
    <Element className={className} {...filterProps(rest)}>
      {children}
    </Element>
  )
}
